<template>
  <div
    :class="[
      chart ? `title-chart` : `title-block`,
      size ? `title-block__size--${size}` : '',
      color ? `title-block__color--${color}` : '',
      type ? `title-block__type--${type}` : '',
      padding ? 'title-spacing' : '',
    ]"
  >
    <h2 :class="[color !== 'white' ? 'title-block__text' : 'title-block__title']" v-html="text" />

    <Tip v-if="tipText" :tip-content="tipText" class="tip-button-reg" />
    <nuxt-link v-if="link" :to="link" class="title-block__link">
      See all
    </nuxt-link>
  </div>
</template>

<script>
export default {
  name: "TitleBlock",
  components: {
    Tip: () => import("../../components/elements/Tip"),
  },
  props: {
    tipText: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
    link: {
      type: String,
      default: null,
    },
    size: {
      type: String,
      default: "default",
    },
    color: {
      type: String,
      default: "default",
    },
    type: {
      type: String,
      default: null,
    },
    padding: {
      type: Boolean,
      default: true,
    },
    chart: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";
.title-spacing {
  margin-bottom: 2rem;
}

.title-chart {
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  position: relative;

  width: auto;

  .tip-button-reg {
    left: 2rem;
    top: 0.2rem;
    width: 17px;
    position: relative;
  }
}
.title-block {
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  width: 100%;

  .tip-button-reg {
    left: 1.5rem;
    top: 0.2rem;
    width: 17px;
    position: relative;
  }

  &__size {
    &--two-string {
      height: 4rem;
      .title-block__text {
        font-size: 1.2rem;
        padding: 0 1.2rem;
        height: 100%;
        &:after {
          border-top-width: 4rem;
        }
      }
    }

    &--accordion-heading {
      .title-block__text {
        font-size: 2.4rem;
        padding: 0 1.2rem;
        line-height: 3rem;
        &:after {
          border-top-width: 3rem;
        }
      }
    }
    &--small {
      // height: 3rem;
      .title-block__text {
        font-size: 1.4rem;
        padding: 0 1.2rem;
        line-height: 3rem;
        &:after {
          border-top-width: 3rem;
        }
      }
    }

    &--default {
      height: 3.6rem;

      .title-block__text {
        font-size: 1.6rem;
        line-height: 3.6rem;
        padding: 0 1.5rem;
        &:after {
          border-top-width: 3.6rem;
        }
        @include below($md) {
          font-size: 1.4rem;
        }
        @include below(350px) {
          font-size: 1.2rem;
        }
      }
    }

    &--large {
      height: 3.6rem;

      .title-block__text {
        font-size: 1.6rem;
        line-height: 3.6rem;
        padding: 0 1.5rem;
        &:after {
          border-top-width: 3.6rem;
        }
        @include below($md) {
          font-size: 2.4rem;
        }
        @include below(350px) {
          font-size: 1.2rem;
        }
      }
    }

    &--accordion-large {
      height: 2.6rem;
      font-size: 2rem;
      .title-block__text {
        font-size: 2.6rem;
        line-height: 3.6rem;
        padding: 0 1.5rem;
        &:after {
          border-top-width: 3.6rem;
        }
        @include below($md) {
          font-size: 2.4rem;
        }
        @include below(350px) {
          font-size: 1.2rem;
        }
      }
    }
  }

  &__color {
    &--gold {
      .title-block__text {
        color: $white;
        background-color: $gold;

        &:after {
          border-top-color: $gold;
        }
      }
    }

    &--gold2 {
      .title-block__text {
        color: $white;
        background-color: $gold2;

        &:after {
          border-top-color: $gold2;
        }
      }
    }

    &--red {
      .title-block__text {
        color: $white;
        background-color: $red;

        &:after {
          border-top-color: $red;
        }
      }
    }

    &--brightgreen {
      .title-block__text {
        color: $white;
        background-color: $brightGreen;

        &:after {
          border-top-color: $brightGreen;
        }
      }
    }
    &--brightblue {
      .title-block__text {
        color: $white;
        background-color: $brightBlue;

        &:after {
          border-top-color: $brightBlue;
        }
      }
    }
    &--corporateblue {
      .title-block__text {
        color: $white;
        background-color: $corporateBlue;

        &:after {
          border-top-color: $corporateBlue;
        }
      }
    }
    &--mediumred {
      .title-block__text {
        color: $white;
        background-color: $medium_red;

        &:after {
          border-top-color: $medium_red;
        }
      }
    }
    &--darkred {
      .title-block__text {
        color: $white;
        background-color: $dark_red;

        &:after {
          border-top-color: $dark_red;
        }
      }
    }

    &--default {
      .title-block__text {
        color: $white;
        background-color: $text;

        &:after {
          border-top-color: $text;
        }
      }
    }

    &--white {
      .title-block__text {
        color: $black;
        background-color: $white;

        &:after {
          border-top-color: $text;
        }
      }
    }
  }

  &__type {
    &--alternative {
      .title-block__text:after {
        transform: rotateX(180deg);
      }
    }
  }

  &__text {
    font-weight: 700;
    text-transform: uppercase;
    z-index: 1;
    position: relative;
    &:after {
      content: "";
      display: block;
      position: absolute;
      width: 0;
      height: 0;
      border-top: 3.6rem solid;
      border-right: 1.3rem solid transparent;
      right: -1.3rem;
      top: 0;
      bottom: 0;
    }
  }

  &__title {
    font-weight: 700;
    text-transform: uppercase;
    z-index: 1;
    position: relative;
  }

  &__link {
    font-size: 1.6rem;
    font-weight: 600;
    color: $red;
    text-decoration: none;
    margin-right: 1rem;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
